import React, { useState, useEffect } from 'react';
import { ArrowDownAZ, ArrowUpAZ, History, Trash2, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import NavBar, { infoUtente, loadNav } from '../../visualComponents/NavBarVend.js';
import * as XLSX from 'xlsx';
import Loader from '../../visualComponents/Loader.js';

let piani = [];
let isLoading = false;


const PopUpDominio = ({ isVisible, setIsVisible, codiceDominio }) => {
    const [infoDominio, setInfoDominio] = useState({});
    const [isFirstTime, setIsFirstTime] = useState(true);
    useEffect(() => {
        const loadInfoDominio = async () => {
            try {
                isLoading = true;
                const response = await fetch('/getDominio', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ CodiceDominio: codiceDominio })
                });
                const data = await response.json();
                isLoading = false;
                setInfoDominio(data[0]);
            } catch (error) {
                alert("Errore nel caricamento delle informazioni del dominio, riprova più tardi.");
                console.error(error);
            }
        };
        if (isFirstTime && isVisible) {
            loadInfoDominio();
            setIsFirstTime(false);
        }
    }, [isVisible]);

    const closeModal = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">Dominio</h2>
                    <button className="text-red-500" onClick={closeModal}>
                        <X size={24} />
                    </button>
                </div>
                <div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Codice/P.IVA: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["CodiceDominio"]}</p>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Indirizzo: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["Indirizzo"]}</p>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">CAP: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["Cap"]}</p>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Città: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["Citta"]}</p>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Provincia: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["Provincia"]}</p>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Ragione Sociale: </p>
                        <p className="rounded w-full bg-white dark:bg-gray-800">{infoDominio["RagioneSociale"]}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TableRow = ({ data, check, onCheckChange }) => {
    const [isPopUpDominioVisible, setIsPopUpDominioVisible] = useState(false);

    const handleElimina = async () => {
        if (!window.confirm("Sei sicuro di voler eliminare questa licenza?")) return;
        try {
            isLoading = true;
            const response = await fetch('/eliminaLicenza', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ID: data.ID })
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                window.location.reload();
            } else {
                isLoading = false;
                window.location.reload();
            }
        } catch (error) {
            alert("Operazione fallita, riprova più tardi.");
            console.log(error);
        }

    };

    return (
        <div className="grid grid-cols-8 gap-1 mt-2">
            <div className='flex items-center justify-end gap-4'>
                <input id={data[0]} type="checkbox" className='w-5 h-5 bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1' checked={check} onChange={onCheckChange} />
            </div>
            <div id={data.ID} className="col-span-6 bg-gray-300 dark:bg-gray-500 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-6 p-4 text-center break-words flex items-center">
                <div>{data.CodiceAttivazione}</div>
                <div>{piani.length > 0 ? piani.find((d) => d.ID === data.IDPiano)?.Nome : "Loading..."}</div>
                <div>{data.ValiditaMesi}</div>
                <div>{data.DataCreazione}</div>
                <div>{data.DataAttivazione === null ? ("------") : (data.DataAttivazione)}</div>
                {data.CodiceDominio === null ? (<div>------</div>) : (<div className='text-blue-500 cursor-pointer' onClick={() => setIsPopUpDominioVisible(true)}><u>{data.CodiceDominio}</u></div>)}
            </div>

            <div className="flex items-center gap-1 ">
                {data.Obsoleta === false ? (
                    <button className="text-red-500" onClick={handleElimina}>
                        <Trash2 size={24} />
                    </button>)
                    : null
                }
            </div>
            <PopUpDominio isVisible={isPopUpDominioVisible} setIsVisible={setIsPopUpDominioVisible} codiceDominio={data.CodiceDominio} />
        </div>
    );
};

const DashVenditore = () => {
    const [indexTabella, setIndexTabella] = useState([
        { value: "Codice", dbCode: "CodiceAttivazione", ascending: true, filter: "text" },
        { value: "Piano", dbCode: "IDPiano", ascending: true, filter: "text" },
        { value: "Validità (mesi)", dbCode: "ValiditaMesi", ascending: true, filter: "number" },
        { value: "Data Creazione", dbCode: "DataCreazione", ascending: true, filter: "text" },
        { value: "Data Attivazione", dbCode: "DataAttivazione", ascending: true, filter: "text" },
        { value: "Dominio", dbCode: "CodiceDominio", ascending: true, filter: "text" }
    ]);
    const [filters, setFilters] = useState({
        CodiceAttivazione: "",
        IDPiano: "",
        ValiditaMesi: "",
        DataCreazione: "",
        DataAttivazione: "",
        CodiceDominio: ""
    });
    const [data, setData] = useState([]);
    const [archive, setArchive] = useState(false);
    const [viewData, setViewData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setViewData(data.filter((d) => d.value["Obsoleta"] === archive));
    }, [data]);

    useEffect(() => {
        let newData = [...data];
        for (const key in filters) {
            if (filters[key] !== "") {
                newData = newData.filter((d) => (d.value[key] !== null ? d.value[key].toString().toLowerCase().includes(filters[key].toLowerCase()) : null));
            }
        };
        setViewData(newData.filter((d) => d.value["Obsoleta"] === archive));
    }, [filters]);

    const onload = async () => {
        try {
            isLoading = true;

            await loadNav();

            const r2 = await fetch('/getPiani', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const rd2 = await r2.json();

            if (r2.status === 500) {
                alert(rd2.error);
                console.log(rd2.error);
                navigate('/');
            } else {
                piani = rd2;

                const r3 = await fetch("/getLicenzeVenditore", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ Venditore: infoUtente.Nome }),
                });

                const rd3 = await r3.json();

                if (r3.status === 500) {
                    alert(rd3.error);
                    console.log(rd3.error);
                    navigate('/');
                } else {
                    isLoading = false;
                    setData(rd3.map((d) => ({ value: d, checked: false })));
                }
            }

        } catch (error) {
            alert("Errore nel caricamento della pagina, riprova più tardi.");
            console.error(error);
            navigate('/');
        }
    };

    const sortByColumn = (column) => {
        setIndexTabella((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabella.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewData];

        newData.sort((a, b) => {
            const valA = a.value[column];
            const valB = b.value[column];

            const isDateFormat = typeof valA === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(valA);

            if (isDateFormat) {
                const dateA = parseDate(valA);
                const dateB = parseDate(valB);
                return isAscending ? dateA - dateB : dateB - dateA;
            }

            if (valA > valB) return isAscending ? -1 : 1;
            if (valA < valB) return isAscending ? 1 : -1;
            return 0;
        });

        setViewData(newData);
    };

    const parseDate = (str) => {
        const [day, month, year] = str.split('/');
        return new Date(`${year}-${month}-${day}`);
    };

    const handleCheckTotale = () => {
        let checkTotale = document.getElementById("tot").checked;
        let newData = [...viewData];
        newData.forEach((d) => d.checked = checkTotale);
        setViewData(newData);
    };

    const handleCheckChange = (id) => {
        let newData = [...data];
        newData.forEach((d, index) => {
            if (d["value"]["ID"] === id) d.checked = !d.checked;
        });
        setData(newData);
    };

    const handleArchive = () => {
        const newArchive = !archive;
        setArchive(newArchive);
        let newData = [...data];
        newData = newData.filter((d) => d.value["Obsoleta"] === newArchive);
        setViewData(newData);
    };

    const handleExport = () => {
        const dataChecked = viewData.filter((d) => d.checked);
        if (dataChecked.length === 0) return;

        const dataSheet = dataChecked.map(d => ({
            CodiceAttivazione: d.value["CodiceAttivazione"],
            Piano: piani.find((p) => p.ID === d.value["IDPiano"]).Nome,
            ValiditaMesi: d.value["ValiditaMesi"],
            Venditore: d.value["Venditore"],
            DataCreazione: d.value["DataCreazione"],
            DataAttivazione: d.value["DataAttivazione"],
            Dominio: d.value["CodiceDominio"]
        }));
        const worksheet = XLSX.utils.json_to_sheet(dataSheet);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Foglio1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "Export.xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page={"HOME"} />
            {isLoading && <Loader />}
            <div className="p-4 bg-white dark:bg-gray-800 text-black dark:text-white">
                <div id="tabella" className="mt-14">
                    <div className="grid grid-cols-8 gap-1 mt-4">
                        <div className='flex items-center justify-end gap-4'>
                            <input id="tot" type="checkbox" className='w-5 h-5' onChange={handleCheckTotale} />
                        </div>
                        <div className="col-span-6 bg-gray-400 dark:bg-gray-600 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-6 p-4 font-bold text-center">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} onClick={() => sortByColumn(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 md:flex md:items-center md:justify-center">
                                        <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                        <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                            {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                        </button>
                                    </div>
                                ))
                            }
                        </div>
                        <div></div>
                    </div>
                    <div className="grid grid-cols-8 gap-4 mt-2">
                        <div></div>
                        <div className="col-span-6 rounded-lg grid grid-cols-6 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 6 ? "pl-2" : "px-2"}`}>
                                        <input
                                            type={d.filter}
                                            placeholder={d.value}
                                            value={filters[d.dbCode]}
                                            className="text-[2vw] md:text-base rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                            onChange={(e) => setFilters({ ...filters, [d.dbCode]: e.target.value })}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                        <div className='flex items-center'>
                            <button className={!archive ? "text-yellow-700" : "text-yellow-300"} onClick={handleArchive}>
                                <History size={24} />
                            </button>
                        </div>
                    </div>
                    {viewData.map((d, index) => (
                        <TableRow key={index} data={d.value} check={d.checked} onCheckChange={() => handleCheckChange(d.value["ID"])} />
                    ))}
                </div>
                <div className='flex justify-center'>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleExport}>
                        EXPORT
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DashVenditore;